import { Button, Modal, ModalDialog, Typography, Box } from '@mui/joy';
import { SessionLimitError, type SessionReplacement } from '../../lib/sessionLimit';

export function SessionChooser({ conflict, loading, onChoose, onCancel }: {
  conflict: SessionLimitError | null;
  loading: boolean;
  onChoose: (replacement: SessionReplacement) => void;
  onCancel: () => void;
}) {
  return (
    <Modal open={!!conflict} onClose={() => { if (!loading) onCancel(); }}>
      <ModalDialog aria-labelledby="session-limit-title" sx={{ maxWidth: 480, width: 'calc(100% - 32px)' }}>
        <Typography id="session-limit-title" level="h3">You have 2 active sessions</Typography>
        <Typography>Choose one to sign out and continue on this device.</Typography>
        {conflict?.sessions.map((session) => (
          <Box key={session.id} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 'sm', p: 2 }}>
            <Typography level="title-md">{session.device}</Typography>
            <Typography level="body-sm">Signed in: {new Date(session.created_at).toLocaleString()}</Typography>
            <Typography level="body-sm">Last active: {new Date(session.last_active_at).toLocaleString()}</Typography>
            <Button sx={{ mt: 1 }} disabled={loading} loading={loading} onClick={() => onChoose({
              session_ticket: conflict.ticket, session_id: session.id,
            })}>Sign out this session and continue</Button>
          </Box>
        ))}
        <Button variant="plain" disabled={loading} onClick={onCancel}>Cancel</Button>
      </ModalDialog>
    </Modal>
  );
}
